module.exports = __webpack_public_path__ + "static/media/parent-logo.adbfc6a2.svg";